import { Canvas, useThree } from "@react-three/fiber";
import { useLayoutEffect } from "react";
import { OrthographicCamera } from "three";

import { YAK_TRAILS_CLIENT_TUNING } from "../tuning";
import { getShowcaseCameraZoom, getShowcaseModelScale } from "./showcaseFraming";
import { VoxelSkin } from "./VoxelSkin";

function ShowcaseCamera() {
  const camera = useThree((state) => state.camera);
  const height = useThree((state) => state.size.height);
  const tuning = YAK_TRAILS_CLIENT_TUNING.showcase;

  useLayoutEffect(() => {
    if (!(camera instanceof OrthographicCamera) || height <= 0) return;
    camera.zoom = getShowcaseCameraZoom(height);
    camera.lookAt(0, tuning.cameraTargetY, 0);
    camera.updateProjectionMatrix();
  }, [camera, height, tuning]);

  return null;
}

export function SkinShowcase({ skinId }: { skinId: string }) {
  const tuning = YAK_TRAILS_CLIENT_TUNING.showcase;
  return (
    <div className="yak-trails__skin-showcase" aria-label={`${skinId} skin preview`}>
      <Canvas
        dpr={tuning.dpr}
        orthographic
        camera={{
          position: tuning.cameraPosition,
          zoom: tuning.initialZoom,
          near: tuning.near,
          far: tuning.far,
        }}
        gl={{ antialias: true, alpha: true, powerPreference: "low-power" }}
      >
        <ShowcaseCamera />
        <ambientLight intensity={tuning.ambientIntensity} />
        <directionalLight position={tuning.directionalPosition} intensity={tuning.directionalIntensity} />
        <group rotation={tuning.modelRotation}>
          <VoxelSkin skinId={skinId} heading={tuning.modelHeading} scale={getShowcaseModelScale(skinId)} />
        </group>
      </Canvas>
    </div>
  );
}
